/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bookora API
 * API for **bookora.net** — multi-tenant SaaS for Iranian beauty clinics and
 * aesthetic doctors.
 *
 * ## Conventions
 *
 * - **Versioning**: customer-facing routes live under `/api/v1/...`. The health
 *   probes (`/health`, `/ready`) are unprefixed and version-neutral.
 * - **Response envelope**: every successful JSON response is
 *   `{ "data": <payload>, "meta"?: <extra> }`.
 * - **Error envelope**: every error response is
 *   `{ "statusCode": number, "code": string, "message": string, "details"?: any, "requestId"?: string }`.
 *   `code` is a stable token from `ErrorCode`; `message` is finished Persian copy.
 * - **Pagination**: list endpoints take 1-indexed `?page=&pageSize=` and return
 *   `{ items, page, pageSize, total, pageCount }` inside `data`.
 * - **Auth**: bearer JWT. Tokens come from `/api/v1/auth/otp/verify` and rotate on
 *   `/api/v1/auth/refresh`. There are no passwords in this product.
 * - **Tenancy**: the access token carries the clinic. Every tenant-scoped query is
 *   filtered by it server-side; a `clinicId` in a path or body must agree with the
 *   token or the request is rejected.
 * - **Currency**: every money field is an integer in **rials**. Panels display
 *   toman (1 toman = 10 rials).
 * - **Quantities**: integer milli-units (`…Milli`, 1 unit = 1000).
 *   **Percentages**: basis points (`…PercentBp`, 1% = 100).
 * - **Timestamps**: UTC ISO-8601. Jalali conversion happens in the UI.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePatientPaymentDto,
  CreatePatientPaymentResponse,
  LinkPatientPaymentDto,
  PatientPaymentResponse,
  PatientPaymentsList200,
  PatientPaymentsListParams,
  PatientPaymentsSummaryParams,
  PaymentSummaryResponse,
  ReceivablesResponse,
  RefundPatientPaymentDto,
  SessionPaymentStateResponse
} from '../model';

import { apiClient } from '../../mutator';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * مبلغ **علامت‌دار** است: مثبت دریافت، منفی عودت. مبالغ به ریال.
 * @summary فهرست دریافت‌ها
 */
export const patientPaymentsList = (
    params?: PatientPaymentsListParams,
 signal?: AbortSignal
) => {


      return apiClient<PatientPaymentsList200>(
      {url: `/api/v1/patient-payments`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientPaymentsListQueryKey = (params?: PatientPaymentsListParams,) => {
    return [
    `/api/v1/patient-payments`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientPaymentsListQueryOptions = <TData = Awaited<ReturnType<typeof patientPaymentsList>>, TError = void>(params?: PatientPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPaymentsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPaymentsList>>> = ({ signal }) => patientPaymentsList(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPaymentsListQueryResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsList>>>
export type PatientPaymentsListQueryError = void


export function usePatientPaymentsList<TData = Awaited<ReturnType<typeof patientPaymentsList>>, TError = void>(
 params: undefined |  PatientPaymentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsList>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsList<TData = Awaited<ReturnType<typeof patientPaymentsList>>, TError = void>(
 params?: PatientPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsList>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsList>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsList<TData = Awaited<ReturnType<typeof patientPaymentsList>>, TError = void>(
 params?: PatientPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary فهرست دریافت‌ها
 */

export function usePatientPaymentsList<TData = Awaited<ReturnType<typeof patientPaymentsList>>, TError = void>(
 params?: PatientPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsList>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPaymentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * **هیچ درگاه پرداختی در کار نیست.** این فقط ثبت دفتری است: پول در کلینیک دریافت شده و اینجا نوشته می‌شود. شمارهٔ پیگیری کارت‌خوان در referenceNote ذخیره می‌شود. مبلغ باید مثبت باشد؛ برای عودت از مسیر refund استفاده کنید.
 * @summary ثبت دریافت از بیمار
 */
export const patientPaymentsCreate = (
    createPatientPaymentDto: CreatePatientPaymentDto,
 signal?: AbortSignal
) => {


      return apiClient<CreatePatientPaymentResponse>(
      {url: `/api/v1/patient-payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPatientPaymentDto, signal
    },
      );
    }




export const getPatientPaymentsCreateMutationKey = () => ['patientPaymentsCreate'] as const;

export const getPatientPaymentsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsCreate>>, TError,PatientPaymentsCreateMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsCreate>>, TError,PatientPaymentsCreateMutationVariables, TContext> => {

const mutationKey = getPatientPaymentsCreateMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPaymentsCreate>>, PatientPaymentsCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  patientPaymentsCreate(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPaymentsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsCreate>>>
    export type PatientPaymentsCreateMutationBody = CreatePatientPaymentDto
    export type PatientPaymentsCreateMutationError = void
    export type PatientPaymentsCreateMutationVariables = {data: CreatePatientPaymentDto}

    /**
 * @summary ثبت دریافت از بیمار
 */
export const usePatientPaymentsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsCreate>>, TError,PatientPaymentsCreateMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPaymentsCreate>>,
        TError,
        PatientPaymentsCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPaymentsCreateMutationOptions(options), queryClient);
    }
    /**
 * عودت‌ها به‌صورت عدد مثبت گزارش می‌شوند و netRials تفاضل آن‌هاست. patientId و method همان فیلترهای فهرست‌اند تا جمع‌ها با ردیف‌های فیلترشده یکی باشند.
 * @summary جمع دریافت‌های یک دورهٔ شمسی
 */
export const patientPaymentsSummary = (
    params?: PatientPaymentsSummaryParams,
 signal?: AbortSignal
) => {


      return apiClient<PaymentSummaryResponse>(
      {url: `/api/v1/patient-payments/summary`, method: 'GET',
        params, signal
    },
      );
    }




export const getPatientPaymentsSummaryQueryKey = (params?: PatientPaymentsSummaryParams,) => {
    return [
    `/api/v1/patient-payments/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getPatientPaymentsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof patientPaymentsSummary>>, TError = void>(params?: PatientPaymentsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPaymentsSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPaymentsSummary>>> = ({ signal }) => patientPaymentsSummary(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPaymentsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsSummary>>>
export type PatientPaymentsSummaryQueryError = void


export function usePatientPaymentsSummary<TData = Awaited<ReturnType<typeof patientPaymentsSummary>>, TError = void>(
 params: undefined |  PatientPaymentsSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsSummary>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsSummary<TData = Awaited<ReturnType<typeof patientPaymentsSummary>>, TError = void>(
 params?: PatientPaymentsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsSummary>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsSummary<TData = Awaited<ReturnType<typeof patientPaymentsSummary>>, TError = void>(
 params?: PatientPaymentsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جمع دریافت‌های یک دورهٔ شمسی
 */

export function usePatientPaymentsSummary<TData = Awaited<ReturnType<typeof patientPaymentsSummary>>, TError = void>(
 params?: PatientPaymentsSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPaymentsSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * جمع مانده بدهی بیماران، تعداد بدهکاران و ده بدهکار اول. محدودیت پزشک اعمال می‌شود. مبالغ به ریال.
 * @summary بدهی بیماران
 */
export const patientPaymentsReceivables = (

 signal?: AbortSignal
) => {


      return apiClient<ReceivablesResponse>(
      {url: `/api/v1/patient-payments/receivables`, method: 'GET', signal
    },
      );
    }




export const getPatientPaymentsReceivablesQueryKey = () => {
    return [
    `/api/v1/patient-payments/receivables`
    ] as const;
    }


export const getPatientPaymentsReceivablesQueryOptions = <TData = Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPaymentsReceivablesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPaymentsReceivables>>> = ({ signal }) => patientPaymentsReceivables(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPaymentsReceivablesQueryResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsReceivables>>>
export type PatientPaymentsReceivablesQueryError = void


export function usePatientPaymentsReceivables<TData = Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsReceivables>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsReceivables>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsReceivables<TData = Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsReceivables>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsReceivables>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsReceivables<TData = Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary بدهی بیماران
 */

export function usePatientPaymentsReceivables<TData = Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsReceivables>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPaymentsReceivablesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * outstandingRials منفی یعنی از بیمار بیشتر از مبلغ جلسه دریافت شده است.
 * @summary وضعیت مالی یک جلسه
 */
export const patientPaymentsSessionState = (
    sessionId: string,
 signal?: AbortSignal
) => {


      return apiClient<SessionPaymentStateResponse>(
      {url: `/api/v1/patient-payments/session/${sessionId}`, method: 'GET', signal
    },
      );
    }




export const getPatientPaymentsSessionStateQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/patient-payments/session/${sessionId}`
    ] as const;
    }


export const getPatientPaymentsSessionStateQueryOptions = <TData = Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError = void>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPaymentsSessionStateQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPaymentsSessionState>>> = ({ signal }) => patientPaymentsSessionState(sessionId, signal);





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPaymentsSessionStateQueryResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsSessionState>>>
export type PatientPaymentsSessionStateQueryError = void


export function usePatientPaymentsSessionState<TData = Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError = void>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsSessionState>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsSessionState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsSessionState<TData = Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsSessionState>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsSessionState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsSessionState<TData = Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت مالی یک جلسه
 */

export function usePatientPaymentsSessionState<TData = Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError = void>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsSessionState>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPaymentsSessionStateQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary جزئیات یک دریافت
 */
export const patientPaymentsGetById = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<PatientPaymentResponse>(
      {url: `/api/v1/patient-payments/${id}`, method: 'GET', signal
    },
      );
    }




export const getPatientPaymentsGetByIdQueryKey = (id: string,) => {
    return [
    `/api/v1/patient-payments/${id}`
    ] as const;
    }


export const getPatientPaymentsGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof patientPaymentsGetById>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsGetById>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientPaymentsGetByIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientPaymentsGetById>>> = ({ signal }) => patientPaymentsGetById(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsGetById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientPaymentsGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsGetById>>>
export type PatientPaymentsGetByIdQueryError = void


export function usePatientPaymentsGetById<TData = Awaited<ReturnType<typeof patientPaymentsGetById>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsGetById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsGetById>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsGetById<TData = Awaited<ReturnType<typeof patientPaymentsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsGetById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientPaymentsGetById>>,
          TError,
          Awaited<ReturnType<typeof patientPaymentsGetById>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientPaymentsGetById<TData = Awaited<ReturnType<typeof patientPaymentsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات یک دریافت
 */

export function usePatientPaymentsGetById<TData = Awaited<ReturnType<typeof patientPaymentsGetById>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientPaymentsGetById>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientPaymentsGetByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * فقط sessionId و patientPackageId تغییر می‌کنند (null یعنی بدون پیوند؛ نفرستادن یعنی دست نزن). مبلغ، روش و تاریخ تغییر نمی‌کنند — اصلاح آن‌ها با عودت است. جلسه و پکیج باید متعلق به همان بیمار باشند. ردیفِ عودت پذیرفته نمی‌شود؛ عودت‌های یک دریافتی همراه خودش جابه‌جا می‌شوند. در گزارش حسابرسی ثبت می‌شود. همان دسترسی ثبت دریافت (finance.record_payment) را می‌خواهد.
 * @summary پیوند یک دریافت به جلسه یا پکیج
 */
export const patientPaymentsLink = (
    id: string,
    linkPatientPaymentDto: LinkPatientPaymentDto,
 signal?: AbortSignal
) => {


      return apiClient<CreatePatientPaymentResponse>(
      {url: `/api/v1/patient-payments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: linkPatientPaymentDto, signal
    },
      );
    }




export const getPatientPaymentsLinkMutationKey = () => ['patientPaymentsLink'] as const;

export const getPatientPaymentsLinkMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsLink>>, TError,PatientPaymentsLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsLink>>, TError,PatientPaymentsLinkMutationVariables, TContext> => {

const mutationKey = getPatientPaymentsLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPaymentsLink>>, PatientPaymentsLinkMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientPaymentsLink(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPaymentsLinkMutationResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsLink>>>
    export type PatientPaymentsLinkMutationBody = LinkPatientPaymentDto
    export type PatientPaymentsLinkMutationError = void
    export type PatientPaymentsLinkMutationVariables = {id: string;data: LinkPatientPaymentDto}

    /**
 * @summary پیوند یک دریافت به جلسه یا پکیج
 */
export const usePatientPaymentsLink = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsLink>>, TError,PatientPaymentsLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPaymentsLink>>,
        TError,
        PatientPaymentsLinkMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPaymentsLinkMutationOptions(options), queryClient);
    }
    /**
 * حذف نرم، برای رکوردی که همان لحظه اشتباه ثبت شده. اصلاح یک پرداخت گزارش‌شده باید با عودت انجام شود، نه حذف — به همین دلیل این مسیر دسترسی سنگین‌تری (finance.manage_expenses) می‌خواهد و در گزارش حسابرسی ثبت می‌شود.
 * @summary حذف یک دریافت اشتباه
 */
export const patientPaymentsRemove = (
    id: string,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/patient-payments/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getPatientPaymentsRemoveMutationKey = () => ['patientPaymentsRemove'] as const;

export const getPatientPaymentsRemoveMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsRemove>>, TError,PatientPaymentsRemoveMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsRemove>>, TError,PatientPaymentsRemoveMutationVariables, TContext> => {

const mutationKey = getPatientPaymentsRemoveMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPaymentsRemove>>, PatientPaymentsRemoveMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  patientPaymentsRemove(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPaymentsRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsRemove>>>

    export type PatientPaymentsRemoveMutationError = void
    export type PatientPaymentsRemoveMutationVariables = {id: string}

    /**
 * @summary حذف یک دریافت اشتباه
 */
export const usePatientPaymentsRemove = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsRemove>>, TError,PatientPaymentsRemoveMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPaymentsRemove>>,
        TError,
        PatientPaymentsRemoveMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPaymentsRemoveMutationOptions(options), queryClient);
    }
    /**
 * یک رکورد با مبلغ **منفی** در برابر پرداخت اصلی می‌سازد. پرداخت اصلی هرگز ویرایش یا حذف نمی‌شود؛ هر دو رویداد در دفتر می‌مانند. جمع عودت‌ها نمی‌تواند از مبلغ اصلی بیشتر شود.
 * @summary ثبت عودت وجه
 */
export const patientPaymentsRefund = (
    id: string,
    refundPatientPaymentDto: RefundPatientPaymentDto,
 signal?: AbortSignal
) => {


      return apiClient<CreatePatientPaymentResponse>(
      {url: `/api/v1/patient-payments/${id}/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refundPatientPaymentDto, signal
    },
      );
    }




export const getPatientPaymentsRefundMutationKey = () => ['patientPaymentsRefund'] as const;

export const getPatientPaymentsRefundMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsRefund>>, TError,PatientPaymentsRefundMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsRefund>>, TError,PatientPaymentsRefundMutationVariables, TContext> => {

const mutationKey = getPatientPaymentsRefundMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientPaymentsRefund>>, PatientPaymentsRefundMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  patientPaymentsRefund(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatientPaymentsRefundMutationResult = NonNullable<Awaited<ReturnType<typeof patientPaymentsRefund>>>
    export type PatientPaymentsRefundMutationBody = RefundPatientPaymentDto
    export type PatientPaymentsRefundMutationError = void
    export type PatientPaymentsRefundMutationVariables = {id: string;data: RefundPatientPaymentDto}

    /**
 * @summary ثبت عودت وجه
 */
export const usePatientPaymentsRefund = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientPaymentsRefund>>, TError,PatientPaymentsRefundMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientPaymentsRefund>>,
        TError,
        PatientPaymentsRefundMutationVariables,
        TContext
      > => {
      return useMutation(getPatientPaymentsRefundMutationOptions(options), queryClient);
    }
